import { Link } from "@tanstack/react-router";
import { MarketingResource } from "creso-core/types";
import { Badge } from "web-design-system";
import { getResourceLink, isResourceNew } from "creso-core/utils";
import { ArticleThumbnail } from "./article-thumbnail";

export function ArticleCard({ item }: { item: MarketingResource }) {
  const isNew = isResourceNew(item);
  return (
    <Link to={getResourceLink(item)} target="_blank" className="no-underline!">
      <div className="flex flex-col overflow-hidden rounded-xl border border-border/60 bg-background h-full gap-2 p-2 relative">
        {isNew ? (
          <Badge
            variant="custom"
            className="absolute top-5 left-5 rounded-sm px-1.5 py-0.5 bg-tag-orange-foreground text-tag-orange text-xxs"
          >
            NEW
          </Badge>
        ) : null}
        <ArticleThumbnail label={item.title} src={item.preview_image ?? ""} />
        <div className="text-sm font-medium truncate px-1 py-2">
          {item.title}
        </div>
      </div>
    </Link>
  );
}
